export const MAIN_ROUTE = '/main'
export const TREATMENT_ROUTE = '/treatment'
export const SPA_ROUTE = '/spa'
export const ROOMS_ROUTE = '/rooms'
export const FOOD_ROUTE = '/food'
export const INFO_ROUTE = '/info'
